
import React from 'react';
import { AffiliateSidebar } from './AffiliateSidebar';
import { AffiliateTopbar } from './AffiliateTopbar';
import { MobileAffiliateTopbar } from './MobileAffiliateTopbar';
import { MobileBottomBar } from '@/components/layout/MobileBottomBar';
import { useSidebar } from "@/components/ui/sidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface AffiliateLayoutProps {
  children: React.ReactNode;
}

export const AffiliateLayout = ({ children }: AffiliateLayoutProps) => {
  const isMobile = useIsMobile();
  
  return (
    <SidebarProvider defaultOpen={!isMobile}>
      <div className="flex h-screen w-full bg-background text-foreground">
        <AffiliateSidebar />
        <div className="flex flex-col flex-1">
          {isMobile ? <MobileAffiliateTopbar /> : <AffiliateTopbar />}
          <main className={cn(
            "flex-1 overflow-auto custom-scrollbar scrollbar-thin scrollbar-thumb-border/40 scrollbar-track-transparent hover:scrollbar-thumb-border/60",
            isMobile ? "p-3 pb-36 safe-area-bottom" : "p-6"  // Increased bottom padding on mobile for the navigation bar
          )}>
            {children}
          </main>
          {isMobile && <MobileBottomBar />}
        </div>
      </div>
    </SidebarProvider>
  );
};
